import { WidgetHelperService } from './../widget-helper.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { CommonService } from '../../../services';
var a = 1000;
@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PieChartComponent implements OnInit {
  @Input('graphData') graphData: any;
  pieData = [];
  chart: Object;
  pieChart;

  options: any;
  constructor(private widgetHelperService: WidgetHelperService, private commonService: CommonService) {

  }

  ngOnChanges() {
    if (this.pieChart) {
      this.getSeriesData();
      this.pieChart.series[0].setData(this.pieData, true);
    }
  }

  ngOnInit() {
    this.getSeriesData();
    let dataL = this.kpiDataLabel(), that = this;
    // this.graphData = {
    //   "timeFrame": "year",
    //   "kpiType": "numeric",
    //   "fetchDataFor": "pie",
    //   "dataFilter": [
    //     {
    //       "label": "time1",
    //       "color": "#ccc",
    //       "data": [
    //         {
    //           "value": 56,
    //           "date": 11
    //         }
    //       ]
    //     }, {
    //       "label": "time2",
    //       "color": "#ddd",
    //       "data": [
    //         {
    //           "value": 95,
    //           "date": 10
    //         }
    //       ]
    //     }, {
    //       "label": "time3",
    //       "color": "#eee",
    //       "data": [
    //         {
    //           "value": 0,
    //           "date": 9
    //         }
    //       ]
    //     }, {
    //       "label": "time4",
    //       "color": "#000",
    //       "data": [
    //         {
    //           "value": 12,
    //           "date": 8
    //         }
    //       ]
    //     }
    //   ]
    // }
    // console.log(JSON.stringify(this.graphData));
    // this.graphData.dataFilter.forEach((v, i) => {
    //   let yAxis = (v.data.length > 0) ? parseFloat(v.data[0].value.toFixed(2)) : 0;
    //   let tempArr = {
    //     name: v.label,
    //     y: yAxis,
    //     color: v.color
    //   }
    //   this.pieData.push(tempArr);
    // });
    // //check if data is available
    // let isData = 0;
    // this.pieData.forEach((pData, i) => {
    //   if (pData.y == 0) {
    //     isData++;
    //   }
    // });
    // if (isData != 0 && this.pieData.length == isData) {
    //   this.pieData = [];
    // }
    // console.log(JSON.stringify(this.pieData));
    //set default data
    this.options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      tooltip: {
        // pointFormat: '<b>{point.percentage:.1f}%</b>',
        pointFormatter: function () {
          let val = parseFloat(this.percentage.toFixed(1));
          return '<b>'+that.commonService.formatNumberString(val, false)+'%</b>';
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          showInLegend: true
        }
      },
      series: [{
        name: this.graphData.timeFrame,
        colorByPoint: true,
        data: this.pieData,
        dataLabels: dataL
      }]
    };
  }

  getSeriesData() {
    this.pieData = [];
    this.graphData.dataFilter.forEach((v, i) => {
      let yAxis = (v.data.length > 0) ? parseFloat(v.data[0].value.toFixed(2)) : 0;
      let tempArr = {
        name: v.label,
        y: yAxis,
        color: v.color
      }
      this.pieData.push(tempArr);
    });
    //check if data is available
    let isData = 0;
    this.pieData.forEach((pData, i) => {
      if (pData.y == 0) {
        isData++;
      }
    });
    if (isData != 0 && this.pieData.length == isData) {
      this.pieData = [];
    }
  }

  savePieInstance(pieInstance) {
    this.pieChart = pieInstance;
  }

  kpiDataLabel() {
    let a = this.widgetHelperService.getSeriesDataLabel(this.graphData, 0), that = this;
    if (a) {
      // a["format"] = '{point.percentage:.1f} %';
      a["formatter"] = function () { return that.commonService.formatNumberString(parseFloat(this.percentage.toFixed(1)), false) + ' %' }
      a["distance"] = -40;
    }
    return a;
    // console.log(a);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/pie-chart/pie-chart.component.ts